import React from 'react'

import BaselineToggle from '../components/baseline-toggle'
import DimensionChart from '../components/dimension-chart'
import DimensionToggle from '../components/dimension-toggle'
import Loading from '../components/loading'
import RegionToggle from '../components/region-toggle'
import request from '../util/request'
import states from '../util/states'

const regions = require('../../../../static/data/region.json');

class Performance extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      baseline: false,
      data: {},
      dimension: 'OVERALL',
      region: '',
      selected: [],
    }
    this.onBaselineChange = this.onBaselineChange.bind(this)
    this.onRegionChange = this.onRegionChange.bind(this)
    this.onDimensionChange = this.onDimensionChange.bind(this)
    this.onSelectedChange = this.onSelectedChange.bind(this)
  }

  componentWillMount() {
    const { data } = this.state
    /* istanbul ignore next */
    if (!data.dimensions) {
      this.loadJSON('dimensions2')
    }
  }

  onBaselineChange(baseline) {
    this.setState({ baseline })
  }

  onRegionChange(region) {
    this.setState({ region })
  }

  onDimensionChange(dimension) {
    this.setState({ dimension })
  }

  onSelectedChange(selected) {
    this.setState({ selected })
  }

  async loadJSON(name) {
    const newData = await request(`/data/${name}.json`)
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        ['dimensions']: newData,
      },
    }))
  }

  chartData() {
    const { data, dimension, baseline } = this.state
    return Object.keys(data.dimensions).map(state => ({
      state,
      value: parseFloat(data.dimensions[state][(baseline ? 0 : 1)][dimension]),
      otherValue: parseFloat(data.dimensions[state][0][dimension]),
      currentValue: parseFloat(data.dimensions[state][1][dimension]),
    })).sort((a, b) => {
      const aCurrent = parseFloat(data.dimensions[a.state][1][dimension])
      const bCurrent = parseFloat(data.dimensions[b.state][1][dimension])
      return bCurrent - aCurrent
    })
  }

  faded() {
    const { region } = this.state
    if (region === '') {
      return []
    }

    return Object.keys(states).filter(state => !regions[region].includes(state))
  }

  render() {
    const { data } = this.state
    if (!data.dimensions) {
      return (<Loading message="Loading data..." />)
    }
    return (
      <div>
        <div className="cmwf--performance-select-groups">
          <BaselineToggle
            selected={this.state.baseline}
            changeHandler={this.onBaselineChange}
          />
          <RegionToggle
            selected={this.state.region}
            changeHandler={this.onRegionChange}
          />
          <DimensionToggle
            selected={this.state.dimension}
            changeHandler={this.onDimensionChange}
          />
        </div>
        <div className="cmwf--performance-chart-wrapper">
          <DimensionChart
            data={this.chartData()}
            faded={this.faded()}
            selected={this.state.selected}
            selectedHandler={this.onSelectedChange}
          />
        </div>
      </div>
    )
  }
}

export default Performance



// WEBPACK FOOTER //
// ./src/components/Visualizations/containers/performance.jsx